import { MachinePublic } from "@aura-frontend/omnibus-az-client";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { cn, Tooltip } from "@win-reality/react-ui";
import { Link } from "react-router-dom";

import { CONTACT_SUPPORT_TOOLTIP } from "@/utils/machineHealth";

type MachineCardProps = {
  field: MachinePublic;
  baseRoute?: string;
};

export const MachineCard = ({
  field,
  baseRoute = "/tagging",
}: MachineCardProps) => {
  const isInactive = field.status !== "active";

  const CardWrapper: React.ElementType = isInactive ? "div" : Link;
  const cardProps = isInactive
    ? {}
    : { to: `${baseRoute}/${field.machineUuid}` };

  return (
    <CardWrapper
      data-testid="machine-card-wrapper"
      {...cardProps}
      className={cn(
        // Layout
        "relative block",
        // Spacing
        "p-6",
        // Border
        "rounded border border-border-input",
        // Background
        "bg-white",
        // Effects
        "transition-shadow",
        // States
        isInactive
          ? "cursor-not-allowed opacity-60"
          : "cursor-pointer hover:bg-gray-50 hover:shadow-md",
      )}
    >
      <div className="flex flex-col gap-2">
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-bold text-text-light">
            {field.name}
          </p>
          <p className="text-sm text-text-light">{field.region}</p>
        </div>

        {isInactive && (
          <Tooltip content={CONTACT_SUPPORT_TOOLTIP} variant="dark">
            <div className="flex shrink-0 items-center gap-1">
              <span className="text-sm italic text-accent-dark-3">
                (under maintenance)
              </span>
              <InformationCircleIcon
                aria-label="machine info"
                className="h-4 w-4 text-accent-dark-3"
              />
            </div>
          </Tooltip>
        )}
      </div>
    </CardWrapper>
  );
};
